import { Utils } from '@treezor/design-system';

import { IAttributeConfig } from '@/features/wallets/store/models/wallet.model';

export function WalletColumnHeader({ attribute, name }: { attribute: IAttributeConfig; name: string }) {
  const group = attribute.name.split('.')[0];
  const hasGroup = group !== attribute.name && group !== undefined && group !== 'date';

  return (
    <div className="w-full flex flex-row justify-center items-center flex-wrap">
      {hasGroup && <span>{`${Utils.capitalize(group)} : `}</span>}
      <span>{name}</span>
    </div>
  );
}
